import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { baseURL } from 'services/api/apiConfig'
import { appSelected } from 'stores/navigation'

let selectedApplication = 'physician'
appSelected.subscribe(value => {
  if (value.toLocaleLowerCase() === 'app') {
    selectedApplication = 'app'
  } else {
    selectedApplication = 'physician'
  }
})

export const getMarketLibraryBlendData = async ({ body }) => {
  return new Promise((resolve, reject) => {
    // setTimeout(() => {
    //   resolve(marketLibraryBlendMock)
    // }, 5000)
    callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/blend`, 'POST', body)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting blend market data')
        reject(error)
      })
  })
}

export const getMarketLibraryBlendDetail = async ({ marketDataHeaderKey }) => {
  return new Promise((resolve, reject) => {
    // setTimeout(() => {
    //   resolve(marketLibraryBlendDetails)
    // }, 5000)
    callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/blend/detail?marketDataHeaderKey=${marketDataHeaderKey}`, 'GET')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting blend market data')
        reject(error)
      })
  })
}

export const postMarketLibraryBlendDataHeader = async ({ body }) => {
  try {
    const data = await callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/blend/header`, 'POST', body)
    return data
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting blend market data')
    throw error
  }
}

export async function postManageDataViewMarketLibraryGrid({ body }) {
  try {
    const data = await callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/grid`, 'POST', body)
    return data
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting view market library')
    throw error
  }

  // return new Promise(resolve => {
  //   callApi()
  //     .then(data => {
  //       resolve(data)
  //     })
  //     .catch(err => {
  //       console.log(err)

  //       resolve([])
  //     })
  // })
}

export async function postManageDataViewMarketLibraryHeader({ body }) {
  return new Promise(resolve => {
    callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/header`, 'POST', body)
      .then(data => {
        // @ts-ignore
        resolve(data)
      })
      .catch(err => {
        console.log(err)
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting view market library')
        resolve([])
      })
  })
}

export async function postManageDataViewMarketLibraryUploadsGrid({ body }) {
  return new Promise(resolve => {
    callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/upload`, 'POST', body)
      .then(data => {
        // @ts-ignore
        resolve(data)
      })
      .catch(err => {
        console.log(err)
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting view market library upload')
        resolve([])
      })
  })
}

export async function postManageDataViewMarketLibraryUploadsHeader({ body }) {
  return new Promise(resolve => {
    callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/upload/header`, 'POST', body)
      .then(data => {
        // @ts-ignore
        resolve(data)
      })
      .catch(err => {
        console.log(err)
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting view market library upload')
        resolve([])
      })
  })
}

export const postManageDataViewMarketLibraryBlendExport = async ({ body }) => {
  try {
    return await callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/blend/export`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting view market library')
    throw error
  }
}

export const postManageDataViewMarketLibraryUploadsExport = async ({ body }) => {
  try {
    return await callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/upload/export`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting view market library')
    throw error
  }
}

export async function postManageDataViewMarketLibraryExport({ body }) {
  try {
    return await callApi(`${baseURL}/manage-data/view-market-library/${selectedApplication}/export`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting view market library')
    throw error
  }
}

export async function getMarketLibraryFilter(body, section) {
  try {
    const sectionPath =
      {
        blends: 'blend',
        uploads: 'upload',
      }[section] || ''

    const url = `${baseURL}/manage-data/view-market-library/${selectedApplication}${sectionPath ? `/${sectionPath}` : ''}/filters`

    return await callApi(url, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting filters for market library')
    throw error
  }
}

// v2 calls Market Library
export async function getMarketLibraryData(data) {
  let url = `${baseURL}/manage-data/view-market-library/${selectedApplication}`
  return new Promise((resolve, reject) => {
    callApi(url, 'POST', data)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        console.log(error)
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving Survey Data.')
        reject(error)
      })
  })
}
